import { render, staticRenderFns } from "./PaytableSymbolDesktop.vue?vue&type=template&id=0e9f8d4a&scoped=true&"
import script from "./PaytableSymbolDesktop.vue?vue&type=script&lang=ts&"
export * from "./PaytableSymbolDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableSymbolDesktop.vue?vue&type=style&index=0&id=0e9f8d4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9f8d4a",
  null
  
)

export default component.exports